import Manager from './manager'

const manager = new Manager()

export default {
	google_analytics: {
		title: 'Google Analytics',
		description: 'Statistiques d\'utilisation',
		allow: (service) =>
		{
			manager.addScript(service.name, `https://www.googletagmanager.com/gtag/js?id=${service.id}`)
			manager.addInlineScript(service.name, `
			window.dataLayer = window.dataLayer || []
		
			function gtag () {dataLayer.push(arguments)}
		
			gtag('js', new Date())
			gtag('config', '${service.id}', { 'anonymize_ip': true })
			gtag('config', '${service.id}', { 'link_attribution': true })
			`)
		},
		decline: (service) =>
		{
			manager.removeScript(service.name)
		}
	},
	google_maps: {
		title: 'Google Maps',
		description: 'Cartes Google',
		allow: (service) =>
		{
			if(service.type === 'iframe'){
				manager.addIframe(service.name, `https://www.google.com/maps/embed?pb=${service.location}`)
			} else {
				manager.addScript(service.name)
			}
		},
		decline: (service) =>
		{
			if(service.type === 'iframe'){
				manager.removeIframe(service.name)
			} else {
				manager.removeScript(service.name)
			}
		}
	},
	clicrdv: {
		title: 'ClicRDV',
		description: 'Prise de rendez-vous en ligne',
		allow: (service) =>
		{
			manager.addIframe(service.name, `https://www.clicrdv.com/${service.id}?popin=1`)
		},
		decline: (service) =>
		{
			manager.removeIframe(service.name)
		}
	}
}
